module.exports = __webpack_public_path__ + "static/media/Shahr.7b6932c5.svg";